import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const channelsSlice = createAppSlice({
  name: 'channels',
  initialState,
  reducers,
});

export const { loadChannels, updateChannel, updateECDNConfiguration } = channelsSlice.actions;

export default channelsSlice.reducer;
